import $ from 'jquery'
import Rx from 'rx'

'use strict'
$(document).ready(() => {
  registerHandler()
  handleSmoothScroll()
})

function registerHandler() {
  const navigationLinkClickStream = _createNavigationLinkClickStream()
  const scrollStream = Rx.Observable.fromEvent(window, 'scroll')
  const closeMenuStream = navigationLinkClickStream.merge(scrollStream)

  closeMenuStream.subscribe(() => {
    _closeMenu()
  })

  const navigationExpandButtonClickStream = _createNavigationExpandButtonClickStream()

  navigationExpandButtonClickStream.subscribe(() => {
    if ($('.navigation-expand-button span').hasClass('open')) {
      _closeMenu()
      return
    }

    _openMenu()
  })
}

function _createNavigationExpandButtonClickStream() {
  const navigationExpandButton = $('.navigation-expand-button')
  const navigationExpandButtonClickStream = Rx.Observable.fromEvent(navigationExpandButton, 'click')

  return navigationExpandButtonClickStream
}

function _createNavigationLinkClickStream() {
  const navigationItem = $('.navigation-item a')
  const navigationBrand = $('.navigation-brand')
  const navigationLinkClickStream = Rx.Observable.fromEvent(navigationItem, 'click')
    .merge(Rx.Observable.fromEvent(navigationBrand, 'click'))

  return navigationLinkClickStream
}

function _closeMenu() {
  $('.navigation-body').removeClass('open')
  $('.navigation-body').css('max-height', '')
  $('.navigation-expand-button span').removeClass('open')
}

function _openMenu() {
  $('.navigation-expand-button span').addClass('open')
  let navigationHeight = $('.navigation-list').outerHeight(true)
  $('.navigation-body').css('max-height', `${navigationHeight}px`)
}

function handleSmoothScroll() {
  $('a').click(_smoothScroll);
}

function _smoothScroll() {
  const SMOOTH_SCROLL_DURATION = 400 //ms

  const scrollPosition = $(this).attr('href') === '#' ? 0 : $($(this).attr('href')).offset().top
  $('html, body').animate({
    scrollTop: scrollPosition
  }, SMOOTH_SCROLL_DURATION);

  return false;
}



// WEBPACK FOOTER //
// ./src/js/main.js